import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="footer-section py-4 mt-auto" style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #e9ecef' }}>
      <Container>
        <Row className="mb-3">
          <Col className="text-center">
            <h6 className="mb-2 fw-bold" style={{ color: '#006e39' }}>Dati Fiscali</h6>
            <p className="mb-1 small text-dark">
              <strong>Codice Fiscale:</strong> 06335770720 &nbsp;|&nbsp;
              <strong>Partita IVA:</strong> 93164310729 &nbsp;|&nbsp;
            </p>
            <p className="mb-0 small text-dark">
              <strong>Sede Legale:</strong> C.so Vittorio Emanuele II, 388 – 74122 Taranto (TA)
            </p>
          </Col>
        </Row>
        <hr className="footer-divider mb-3" style={{ borderColor: '#dee2e6' }} />
        <Row>
          <Col md={6} className="text-center text-md-start mb-2 mb-md-0">
            <p className="mb-0 small text-muted">
              © {new Date().getFullYear()} UISP - Tutti i diritti riservati
            </p>
          </Col>
          <Col md={6} className="text-center text-md-end">
            <p className="mb-0 small text-muted">
              Sistema di Gestione Eventi
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;